export default __webpack_public_path__ + "38f3a621fa702c4a34e56189b6070129.svg";